import React, { useState, useMemo } from 'react';
import { Container, Col, Row } from "react-bootstrap";
import { StyledKfTable } from '../../../../Styling/styledTable/StyledTable';
import usePaginator from '../../../../components/useTable/UsePaginator';
import UseTableSorter from '../../../../components/useTable/UseTable';
import { TableBorder, TitleSectionTables, KredittvurderingForm, KredittvurderingTd, StyledKvTable } from '../../../../Styling/styledKredittvurdering/styledKvComponents';


const UtleggstrekkTable = (props) => {

    const localeMessages = props.localeMessages
    const kvState = props.kredittvurderingState;
    const ratingData = props.fetchedRating;

    // State for grid sorting
    const [currentSeq, setCurrentSeq] = useState('up'); // default
    const [currentField, setCurrentField] = useState('debtorName');    // feltnavn
    const [currentType, setCurrentType] = useState('string'); // num
    const [sortClicked, setSortClicked] = useState(0);

    const [masterT1ChangeSortField, t1GetSortFunc, t1IndicaterIcon] = UseTableSorter(
        currentSeq, setCurrentSeq,
        currentField, setCurrentField,
        currentType, setCurrentType
    )

    // Nødvendig pga henting av memoised felt
    const t1ChangeSortField = (fieldName, fieldType) => {
        masterT1ChangeSortField(fieldName, fieldType)

        // Sett trigger for å tvinge memoized function til rerender
        setSortClicked(Date.now())
    }

    const sortedData = useMemo(
        () => {
            if (ratingData.length > 0) {
                return ratingData.sort(t1GetSortFunc().fn)
            }
            else {
                return []
            }
        },
        [ratingData, sortClicked]
    );

    // state for grid paginator
    const [numberPrPage, setNumberPerPage] = useState(5)
    const [activePage, setActivePage] = useState(1);
    const [showAll, setShowAll] = useState(false);


    const [Paginate, PaginationNav, PaginationDropdown, PaginationIndex, resetPagination] = usePaginator(
        sortedData,
        numberPrPage, setNumberPerPage,
        activePage, setActivePage
    )
    
    const printHeader = (t1IndicaterIcon, t1ChangeSortField) => {
      return (
        <thead>
            <tr>
                <th style={{ whiteSpace: 'normal', overflowWrap: 'break-word', backgroundColor: 'white' }} onClick={() => t1ChangeSortField('caseNumber', 'string')}>{localeMessages['GH_saksnummer']}{t1IndicaterIcon('caseNumber')}</th>
                <th style={{ whiteSpace: 'normal', overflowWrap: 'break-word', backgroundColor: 'white' }} onClick={() => t1ChangeSortField('monthlyAmount', 'num')}>{localeMessages['GH_beloepPerMnd']}{t1IndicaterIcon('monthlyAmount')}</th>
                <th style={{ whiteSpace: 'normal', overflowWrap: 'break-word', backgroundColor: 'white' }} onClick={() => t1ChangeSortField('startDate', 'datetime')}>{localeMessages['GH_startdato']}{t1IndicaterIcon('startDate')}</th>
                <th style={{ whiteSpace: 'normal', overflowWrap: 'break-word', backgroundColor: 'white' }} onClick={() => t1ChangeSortField('endDate', 'datetime')}>{localeMessages['GH_sluttdato']}{t1IndicaterIcon('endDate')}</th>
                <th style={{ whiteSpace: 'normal', overflowWrap: 'break-word', backgroundColor: 'white' }} onClick={() => t1ChangeSortField('hearingHeld', 'string')}>{localeMessages['GH_avholdtForretning']}{t1IndicaterIcon('hearingHeld')}</th>
                <th style={{ whiteSpace: 'normal', overflowWrap: 'break-word', backgroundColor: 'white' }} onClick={() => t1ChangeSortField('saksoekerOrgNr', 'string')}>{localeMessages['GH_saksoekerOrgnr']}{t1IndicaterIcon('saksoekerOrgNr')}</th>
                <th style={{ whiteSpace: 'normal', overflowWrap: 'break-word', backgroundColor: 'white' }} onClick={() => t1ChangeSortField('saksoekerForetaksnavn', 'string')}>{localeMessages['GH_saksoekerForetaksnavn']}{t1IndicaterIcon('saksoekerForetaksnavn')}</th>
                <th style={{ whiteSpace: 'normal', overflowWrap: 'break-word', backgroundColor: 'white' }} onClick={() => t1ChangeSortField('prosessfullmektigOrgnr', 'string')}>{localeMessages['GH_prosessfullmektigOrgnr']}{t1IndicaterIcon('prosessfullmektigOrgnr')}</th>
                <th style={{ whiteSpace: 'normal', overflowWrap: 'break-word', backgroundColor: 'white' }} onClick={() => t1ChangeSortField('prosessfullmektigForetaksnavn', 'string')}>{localeMessages['GH_prosessfullmektigForetaksnavn']}{t1IndicaterIcon('prosessfullmektigForetaksnavn')}</th>
                <th style={{ whiteSpace: 'normal', overflowWrap: 'break-word', backgroundColor: 'white' }} onClick={() => t1ChangeSortField('namsmyndighetOrgnr', 'string')}>{localeMessages['GH_namsmyndighetOrgnr']}{t1IndicaterIcon('namsmyndighetOrgnr')}</th>
                <th style={{ whiteSpace: 'normal', overflowWrap: 'break-word', backgroundColor: 'white' }} onClick={() => t1ChangeSortField('namsmyndighetForetaksnavn', 'string')}>{localeMessages['GH_namsmyndighetForetaksnavn']}{t1IndicaterIcon('namsmyndighetForetaksnavn')}</th>
            </tr>
        </thead>
      )
    }

    const printRow = (model) => {
        return (
            <tr key={model.i} >
               <KredittvurderingTd>{model.caseNumber}</KredittvurderingTd>
               <KredittvurderingTd>{model.monthlyAmount}</KredittvurderingTd>
               <KredittvurderingTd>{model.startDate}</KredittvurderingTd>
               <KredittvurderingTd>{model.endDate}</KredittvurderingTd>
               <KredittvurderingTd>{model.hearingHeld}</KredittvurderingTd>
               <KredittvurderingTd>{model.claimant.organisationId}</KredittvurderingTd>
               <KredittvurderingTd>{model.claimant.name}</KredittvurderingTd>
               <KredittvurderingTd>{model.processRepresentativeAgent.organisationId}</KredittvurderingTd>
               <KredittvurderingTd>{model.processRepresentativeAgent.name}</KredittvurderingTd>
               <KredittvurderingTd>{model.enforcementAuthority.organisationId}</KredittvurderingTd>
               <KredittvurderingTd>{model.enforcementAuthority.name}</KredittvurderingTd>
           </tr>
        )
    }

    return (
        <>
            <Container fluid="true">
                <TableBorder>
                    <KredittvurderingForm>
                        <Col xs={12} md={12}>
                            <TitleSectionTables>Utleggstrekk</TitleSectionTables>
                            <PaginationDropdown />
                            <StyledKvTable>
                                {printHeader(t1IndicaterIcon, t1ChangeSortField)}

                                <tbody>
                                    <Paginate>
                                        {/* paginate forventer en funksjon */}
                                        {row => printRow(row)}
                                    </Paginate>
                                </tbody>
                            </StyledKvTable>
                            <br />
                            <PaginationIndex />
                            <br />
                            <PaginationNav />
                            <br/>
                        </Col>
                    </KredittvurderingForm>
                </TableBorder>            
            </Container>

        </>
    )
}

export default UtleggstrekkTable



